export default {
	API_URL             : 'fiddev.ctgdemo.com/api',
	API_PROTOCOL        : 'https',
	NODE_ENV            : 'prod',
	GOOGLE_MAPS_API_KEY : 'AIzaSyBe_Cc47GkCS8id2yNDNc36I-B2q1nic1A',
	PACKAGE_VERSION     : '1.6.2',
};
